export const MAX_VOICE_ERRORS = 5;
export const VOICE_API_TIMEOUT_MS = 25000;
export const VOICE_IDLE_GUARD_MS = 6000;
